// @ts-expect-error because ~c
import * as exports from '~c/exports'

export const DEFAULT_MENU = exports.DEFAULT_MENU ?? 'empty'
export const DEFAULT_MENU_WHEN_SKU = exports.DEFAULT_MENU_WHEN_SKU ?? null
export const SKU_MATCHES = exports.SKU_MATCHES ?? []

// https://github.com/webpack/webpack/issues/14814
export const SKU_OMITS = exports['SKU_OMITS'.toString()]
export const I18N_RESOURCES = exports['I18N_RESOURCES'.toString()] ?? {}
